<template>
	<div class="pb1">
		<div class="success_top">
			<div class="su_head text-left clearfix">
				<router-link class="logo" to="/index">
					<img src="../../../assets/logo.png" alt="" />
				</router-link>
				<router-link class="user" to="/person">
					<img :src="headImg" alt="" />
				</router-link>
			</div>
			<!--  -->
			<div class="cart-info">
				<h4>您已成功付费</h4>
			</div>
		</div>
		<!-- 个人资料 -->
		<div class="su_list">
			<div class="su_item_con clearfix">
				<p class="su_ol pull-left">• 个人资料</p>
				<a v-if="data.user" class="su_btn btn_over">已完成</a>
				<router-link v-else class="su_btn btn_active" :to="{path: '/totoring_informations'}">去填写</router-link>
			</div>
		</div>
		<!-- 完成专业测评 -->
		<div class="su_list">
			<div class="su_item_con clearfix">
				<p class="su_ol pull-left">• 完成专业测评</p>
				<div v-if="data.user">
					<a v-if="data.user && data.evaluating" class="su_btn btn_over">已完成</a>
					<a v-else class="su_btn btn_active" :href="jumpurl">去测评</a>
				</div>
				<div v-else>
					<a class="su_btn">去测评</a>
				</div>
			</div>
		</div>
		<!-- 选择辅导时间 -->
		<div class="su_list">
			<div class="su_item_con clearfix">
				<p class="su_ol pull-left">• 选择辅导时间</p>
				<div v-if="data.user && data.evaluating">
					<a v-if="data.time_slot" class="su_btn btn_over">已完成</a>
					<router-link v-else class="su_btn btn_active" :to="{path: '/totoring_coaching_time', query: {teacherid: data.teacherid }}">选择时间</router-link>
				</div>
				<div v-else>
					<a class="su_btn">选择时间</a>
				</div>
			</div>
		</div>
		<!-- 辅导须知 -->
		<div class="su_list">
			<div class="su_item_con clearfix">
				<div class="su_ol pull-left">• 辅导须知<p>辅导前 30 分钟可查看</p></div>
				<div v-if="data.user && data.evaluating && data.time_slot && data.notice">
					<a v-if="data.is_server" class="su_btn btn_over">已完成</a>
					<router-link v-else class="su_btn btn_active" :to="{path: '/totoring_consent_form'}">查看须知</router-link>
				</div>
				<div v-else>
					<a class="su_btn">查看须知</a>
				</div>
			</div>
		</div>
		<!-- 查看报告 -->
		<div class="su_list">
			<div class="su_item_con clearfix">
				<div class="su_ol pull-left">• 查看报告</div>
				<div v-if="data.user && data.evaluating && data.time_slot && data.is_server && data.report">
					<router-link class="su_btn btn_active" :to="{path: '/mentor_report', query: {pay: $route.query.pay}}">查看报告</router-link>
				</div>
				<div v-else>
					<a class="su_btn">查看报告</a>
				</div>
			</div>
		</div>
		<!-- 弹窗 -->
		<van-popup class="radius" :close-on-click-overlay="true" v-model="pop_show">
			<div class="pb-public">
				<div class="pop2">
					<h2>重要提示</h2>
					<p class="text-center">您已经成功购买一对一辅导！</p>
					<p class="text-center">为了我们更好的服务，请您务必关注下方微信公众号</p>
					<img src="@a/ewm.jpg" alt="" />
					<div class="pop-footer">
						<button @click="pop_show = false">我已关注</button>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import { createpmqdata, coach } from '@/api/totoring'
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				pop_show: false,
				headImg: "",
				data: {},
				pay: "",
				jumpurl: ""
			}
		},
		methods: {
			pullData(){
				let q = this.$route.query;
				let p1 = createpmqdata();
				let p2 = coach({pay: q.pay});
				Promise.all([p1, p2])
				.then((DL) => {
					// 头像
					this.headImg = DL[1].headimg;
					// 数据
					this.data = DL[1];
					// 第三方测评
					this.jumpurl = DL[0].jumpurl;
					shareCon("totoring",this);
				})
				this.pay = q.pay;
			},
			InitData(){
				let q = this.$route.query;
				if(q.pay == 'ok'){
					this.pop_show = true;
				}
			}
		},
		mounted(){
			this.InitData();
		},
		created(){
			this.pullData();
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.pb1{
		padding-bottom: changeRem(1.2)+px;
	}
	.success_top{
		width: 100%;
		height: auto;
		padding: changeRem(0.6)+px;
		padding-top: 0;
		background: linear-gradient(-90deg, rgba(235, 80, 50, 1) 0%, rgba(245, 127, 23, 1) 100%);
		text-align: center;
		.su_head{
			padding: changeRem(0.4)+px 0px;
			img{
				max-width: 100%;
			}
		}
		.logo{
			display: inline-block;
			width: changeRem(4.8)+px;
		}
		.user{
			float: right;
			width: changeRem(1.2)+px;
			border-radius: changeRem(0.6)+px;
			overflow: hidden;
		}
		.cart-info{
			height: changeRem(3.6)+px;
			background: rgba(255, 255, 255, 1);
			width: changeRem(13.8)+px;
			border-radius: changeRem(0.24)+px;
			line-height: changeRem(3.6)+px;
			color: rgba(235, 80, 50, 1);
			font-size: changeRem(0.64)+px;
		}
	}
	.su_list{
		padding: changeRem(0.6)+px;
		background: rgba(255, 255, 255, 1);
		margin-top: changeRem(0.6)+px;
		height: changeRem(3.6)+px;
		.su_item_con{
			margin-top: changeRem(0.7)+px;
		}
		.su_ol{
			font-size: 34px;
	    line-height: changeRem(1.08)+px;
	    width: changeRem(10)+px;
	    p{
	    	font-size: changeRem(0.533333)+px;
		    line-height: changeRem(0.72)+px;
		    width: changeRem(6.666667)+px;
		    color: #666666;
	    }
		}
		.su_btn{
			float: right;
	    width: changeRem(3.04)+px;
	    height: changeRem(1.08)+px;
	    border: changeRem(0.04)+px solid rgba(204, 204, 204, 1);
	    border-radius: changeRem(0.54)+px;
	    display: block;
	    line-height: changeRem(1.08)+px;
	    text-align: center;
	    font-size: changeRem(0.52)+px;
	    color: #ccc;
		}
		.btn_active{
			background: #EB5032;
	    border: none;
	    color: #fff;
		}
		.btn_over{
	    background: #ccc;
	    border: none;
	    color: #fff;
		}
	}
	.radius{
		border-radius: 20px;
	}
	.pop2{
		padding: 40px 40px 20px;
		width: 8rem;
		h2{
			text-align: center;
	    font-size: changeRem(0.68)+px;
	    color: #333;
	    padding: 0 0 changeRem(0.6)+px 0;
	    font-weight: bold;
		}
		img{
			width: changeRem(6.4)+px;
			margin: 0 auto;
			display: block;
		}
		.pop-footer{
			padding: 0 0 40px;
			button{
				border: 0;
				display: block;
		    margin: 0 auto;
		    margin-top: changeRem(1.4)+px;
		    width: changeRem(7.7)+px;
		    height: changeRem(1.6)+px;
		    line-height: changeRem(1.6)+px;
		    background: rgba(235, 80, 50, 1);
		    border-radius: changeRem(0.16)+px;
		    color: #fff;
		    font-size: changeRem(0.68)+px;
			}
		}
	}
</style>